// Sort pks in descending order
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
export function sortPks (a: { pk: number }, b: { pk: number }): number {
  if (a.pk < b.pk) {
    return 1
  }
  if (a.pk > b.pk) {
    return -1
  }
  // a must be equal to b
  return 0
}
